import { STALE_TIME } from 'business/constants';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { Response } from 'routes/HumanResourcesModule/business/types';
import {
    EnvelopePreviousSimulationData,
    EnvelopeHistoricData,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/helpers/types';
import { RQAPICallWithData } from 'store/APIClient';

const useGenericQuery = <T>(apiCacheKey: QueryKey, endpoint: string) =>
    useQuery({
        queryKey: apiCacheKey,
        queryFn: async () => {
            const response = await RQAPICallWithData<Response<T>>({
                endpoint,
            });
            return response.content.data;
        },
        staleTime: STALE_TIME,
    });

export const useGetHrSimulationHistoricData = (
    apiCacheKey: QueryKey,
    endpoint: string,
) => useGenericQuery<EnvelopeHistoricData>(apiCacheKey, endpoint);

export const useGetHrSimulationPreviousData = (
    apiCacheKey: QueryKey,
    endpoint: string,
) => useGenericQuery<EnvelopePreviousSimulationData>(apiCacheKey, endpoint);
